import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
// import { simpleSetPayload, simpleFieldSelectorFunc } from "../constants";
import { sortByFieldAlphabetically } from "@amplio-common/funcs/commonFunctionalities";
import { VIDEO_SESSION_PAGES as VSP } from "@app/common/data/ActivitiessEnums";
import { PREVIEW_BOARD_ID, simpleSetPayload } from "../constants";
import { getPinnedBoard, getPreviewBoardMode } from "./contentSlice";
import { SLICE_NAMES } from "./sliceNames";

//define root selector

const H5P_GAMES_SLICE_STATE_ROOT_SELECTOR = state => state[SLICE_NAMES?.H5P_SLICE];
// const rootSelector = s => createSelector(H5P_GAMES_SLICE_STATE_ROOT_SELECTOR, s);

const sortFunc = sortByFieldAlphabetically("name");

const createSimpleSelector = (fieldName) => createSelector(
  [state => state[SLICE_NAMES?.H5P_SLICE][fieldName]], field => field,
);

export const h5pGamesStudentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});


export const h5pGamesMapTSToStudentStatus = (ts) => ({
  id: ts.student.id,
  name: ts.student.name,
  h5pGame: null,
  isMultiStudent: false,
  h5pGamePostMessageHandler: () => {},
});

const h5pGamesStudentsAdapterSelectors = h5pGamesStudentsAdapter.getSelectors(H5P_GAMES_SLICE_STATE_ROOT_SELECTOR);

const initialState = {
  previewH5PGame: null,
  isPreviewH5PGameDone: false,
  previewListUUID: false,
  previewH5PPostMessageHandler: () => {},
  ...h5pGamesStudentsAdapter.getInitialState(),
};

export const h5pGamesSlice = createSlice({
  name: SLICE_NAMES?.H5P_SLICE,
  initialState,
  reducers: {
    cleareH5P: () => ({ ...initialState }),
    setPreviewH5PGame: (state, action) => {
      state.previewH5PGame = action?.payload;
      state.isPreviewH5PGameDone = false;
    },
    setIsPreviewH5PGameDone: simpleSetPayload("isPreviewH5PGameDone"),
    setPreviewH5PPostMessageHandler: simpleSetPayload("previewH5PPostMessageHandler"),
    H5PWebsocketUpdate: () => {}, // used for websocket updates. caught by ws-middleware
    H5PPreviewWebsocketUpdate: () => {},
    H5PReassignGame: () => {},
    setPreviewListUUID: simpleSetPayload("previewListUUID"),
    h5pGamesUpdateStudentStatus: h5pGamesStudentsAdapter.updateOne,
    h5pGamesSetStudentsStatus: h5pGamesStudentsAdapter.setAll,
    h5pGamesUpdateAllStudents: h5pGamesStudentsAdapter.updateMany,
    setIsMultiStudentGame: simpleSetPayload("isMultiStudent"),
  },
  extraReducers: {

  },
});

export default h5pGamesSlice.reducer;

//actions

export const { cleareH5P, setPreviewH5PGame, h5pGamesSetStudentsStatus, h5pGamesUpdateStudentStatus,
  h5pGamesUpdateAllStudents, H5PWebsocketUpdate, setPreviewH5PPostMessageHandler, H5PPreviewWebsocketUpdate,
  setPreviewListUUID, H5PReassignGame, setIsPreviewH5PGameDone, setIsMultiStudentGame,
} = h5pGamesSlice.actions;


//selectors
export const {
  selectAll: h5pGamesSelectAllStudentsStatus, selectIds: h5pGamesSelectStudentStatusIds, selectById: h5pGamesSelectStudentStatusById,
} = h5pGamesStudentsAdapterSelectors;

const getPreviewH5PGame = state => state[SLICE_NAMES?.H5P_SLICE].previewH5PGame;

export const selectPreviewH5PGame = createSimpleSelector("previewH5PGame");
export const selectIsPreviewH5PGameDone = createSimpleSelector("isPreviewH5PGameDone");
export const selectPreviewListUUID = createSimpleSelector("previewListUUID");
export const selectPreviewH5PPostMessageHandler = createSimpleSelector("previewH5PPostMessageHandler");
  
export const selectIsShowH5PPreviewGame = createSelector(
  [getPreviewH5PGame, getPreviewBoardMode, getPinnedBoard],
  (previewH5PGame, previewBoardMode, pinnedBoard) => previewBoardMode === VSP.VOCABULARY && previewH5PGame?.id && pinnedBoard === PREVIEW_BOARD_ID,
);

export const selectIsShowH5PPreviewGameOutOfTreatment = createSelector([getPreviewH5PGame], previewH5PGame => !!previewH5PGame?.id);

export const selectIsShowH5PGameList = createSelector(
  [getPreviewH5PGame, getPreviewBoardMode, getPinnedBoard],
  (previewH5PGame, previewBoardMode, pinnedBoard) => previewBoardMode === VSP.VOCABULARY && !previewH5PGame?.id
  && pinnedBoard === PREVIEW_BOARD_ID,
);

export const selectH5PGame = createSelector(
  [getPinnedBoard, getPreviewH5PGame, h5pGamesStudentsAdapterSelectors.selectEntities],
  (pinnedBoard, previewH5PGame, studentStatus) => pinnedBoard === PREVIEW_BOARD_ID ? previewH5PGame : studentStatus[pinnedBoard].h5pGame,
);

export const selectH5PGameByStudentId = createSelector(
  [h5pGamesSelectStudentStatusById], (student => student?.h5pGame),
);

export const selectIsMultiStudentGame = createSimpleSelector("isMultiStudent");
